import { render } from "./ComponenteInputPPAPerfiles.vue?vue&type=template&id=6cdd6d86"
import script from "./ComponenteInputPPAPerfiles.vue?vue&type=script&lang=js"
export * from "./ComponenteInputPPAPerfiles.vue?vue&type=script&lang=js"

import "./ComponenteInputPPAPerfiles.vue?vue&type=style&index=0&id=6cdd6d86&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__